<atx-anchor [href]="link" [newTab]="newTab">
  <ng-content></ng-content>
</atx-anchor>
